import React from 'react';
import { CustomField } from '../../../../../types/custom_field/customField';
import { itemsContainText } from '../../../../../util/string.util';
import { BaseFilter, BaseFilterProps } from '../../common/BaseFilter';
import { t } from '../../../../../types/translation/Translator';
import { FilterProps, FilterStorageKey } from '../../common/filter.util';
import { CustomFieldEntitySubTypeFilter } from './CustomFieldEntitySubTypeFilter';
import { CustomFieldEntityTypeFilter } from './CustomFieldEntityTypeFilter';
import { CustomFieldTypeFilter } from './CustomFieldTypeFilter';
import { CustomFieldPropertiesFilterDropdownContent } from './DropdownContent/CustomFieldFilterDropdownContent';
import { CustomFieldFilterInnerContent } from './DropdownContent/CustomFieldFilterInnerContent';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';

export class CustomFieldPropertiesFilter extends BaseFilter<CustomField> {
  constructor() {
    super(FilterStorageKey.CUSTOM_FIELD);
  }
  filterOptions(): BaseFilter<any>[] {
    return [new CustomFieldEntityTypeFilter(), new CustomFieldEntitySubTypeFilter(), new CustomFieldTypeFilter()];
  }
  toLabel(): string {
    return t(TranslationKey.customFields).singular.label;
  }

  toIcon(): React.JSX.Element {
    return <></>;
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <CustomFieldPropertiesFilterDropdownContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <CustomFieldFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toCount(): number {
    return 0;
  }

  search(item: CustomField, query: string) {
    return itemsContainText(query, [item.name, item.entityType, item.entitySubtype]);
  }

  filteredItems(items: CustomField[], query: string, filterProps: FilterProps): CustomField[] {
    return items.filter(item => {
      if (filterProps.customFieldEntityType?.size && !filterProps.customFieldEntityType.has(item.entityType)) {
        return false;
      }

      if (filterProps.customFieldType?.size && !filterProps.customFieldType.has(item.type)) return false;

      if (
        filterProps.customFieldEntitySubType?.size &&
        !filterProps.customFieldEntitySubType.has(item.entitySubtype || '')
      ) {
        return false;
      }

      return this.search(item, query);
    });
  }
}
